import * as types from "./organizationType";

export const fetchOrganizations = (payload) => ({
  type: types.FETCH_LIST_ORGANIZATIONS_REQUEST,
  payload: payload,
});

export const fetchOrganizationById = (id) => ({
  type: types.FETCH_ORGANIZATION_REQUEST,
  payload: id,
});

export const addOrganization = (userData) => ({
  type: types.ADD_ORGANIZATION_REQUEST,
  payload: userData,
});

export const updateOrganization = (id, userData) => ({
  type: types.UPDATE_ORGANIZATION_REQUEST,
  payload: { id, userData },
});

export const deleteOrganization = (id) => ({
  type: types.DELETE_ORGANIZATION_REQUEST,
  payload: id,
});

export const resetCurrentOrganization = () => ({
  type: types.RESET_CURRENT_ORGANIZATION,
});
